
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-offers",
      function () {
        return require("private-next-pages/job-offers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-offers"])
      });
    }
  